var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_808_38922)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 5H22.5V19H2.5V5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 9H22.5V19H2.5V9Z",
    fill: "#0039A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 14H22.5V19H2.5V14Z",
    fill: "#D52B1E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 5.1,
    width: 19.8,
    height: 13.8,
    rx: 2.9,
    stroke: "#DBE4F0",
    strokeWidth: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_808_38922"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5,
    width: 20,
    height: 14,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuFlag);
export default __webpack_public_path__ + "static/media/RU_flag.14310a77b6e63fd9621eca1ee0a67f3b.svg";
export { ForwardRef as ReactComponent };